export const COLLECTION_NAME = "plans";

export { createPlan } from "./createPlan";
export { getPlan } from "./getPlan";
export { searchPlans } from "./searchPlans";
export { updatePlan } from "./updatePlan";
export { useFetchPlans } from "./fetchPlans";
